import { ITaskData, IInteractionData } from "@origin-digital/reporting-client";

// TODO
// Need to be moved at a later stage - headless CMS?

// Only using part of the events to detect the right one is fired.

type uriType = {
  label: string;
  regex?: string;
};

export type InteractionType = Pick<
  IInteractionData,
  "appName" | "componentType" | "id" | "path"
>;
export type TaskType = Pick<ITaskData, "appName" | "type" | "action">;
export type NavigationType = {
  appName: string;
  uri: uriType;
};
export type NavigationCardType = {
  appName: string;
  path: string;
};

export type ForceCreateUserType = {
  regex: string;
};

type WhiteListBrazeType = {
  events: {
    interaction: InteractionType[];
    task: TaskType[];
    navigation: NavigationType[];
    navigationCard: NavigationCardType[];
  };
  forceCreateUser: ForceCreateUserType[]; // search on path online
};

export const WHITE_LIST_BRAZE: WhiteListBrazeType = {
  events: {
    interaction: [
      {
        appName: "rx-my-account:reward",
        componentType: "button",
        id: "generate-barcode",
      },
      {
        appName: "salesForm",
        componentType: "button",
        id: "add-button-broadband",
      },
      {
        appName: "salesForm",
        componentType: "button",
        id: "continue-without-login",
      },
      {
        appName: "salesForm",
        componentType: "button",
        id: "login",
      },
    ],
    task: [
      {
        appName: "ohm",
        type: "ohm-connect-registration",
        action: "start",
      },
      {
        appName: "ohm",
        type: "ohm-connect-registration",
        action: "complete",
      },
      {
        appName: "salesForm",
        type: "resi-customer-broadband",
        action: "start",
      },
      {
        appName: "salesForm",
        type: "resi-customer-broadband",
        action: "complete",
      },
      {
        appName: "salesForm",
        type: "resi-customer-move",
        action: "start",
      },
      {
        appName: "salesForm",
        type: "resi-customer-move",
        action: "complete",
      },
      {
        appName: "salesForm",
        type: "resi-customer-product-change",
        action: "start",
      },
      {
        appName: "salesForm",
        type: "resi-customer-product-change",
        action: "complete",
      },
      {
        appName: "salesForm",
        type: "resi-customer-switch",
        action: "start",
      },
      {
        appName: "salesForm",
        type: "resi-customer-switch",
        action: "complete",
      },
      {
        appName: "salesForm",
        type: "resi-prospect-broadband",
        action: "start",
      },
      {
        appName: "salesForm",
        type: "resi-prospect-broadband",
        action: "complete",
      },
      {
        appName: "salesForm",
        type: "resi-prospect-move",
        action: "start",
      },
      {
        appName: "salesForm",
        type: "resi-prospect-move",
        action: "complete",
      },
      {
        appName: "salesForm",
        type: "resi-prospect-lpg",
        action: "start",
      },
      {
        appName: "salesForm",
        type: "resi-prospect-lpg",
        action: "complete",
      },
      {
        appName: "salesForm",
        type: "resi-prospect-switch",
        action: "start",
      },
      {
        appName: "salesForm",
        type: "resi-prospect-switch",
        action: "complete",
      },
    ],
    navigation: [
      {
        appName: "movesrx",
        uri: {
          label: "originenergy/my/disconnect/success",
        },
      },
      {
        appName: "profile-rx",
        uri: {
          label: "originenergy/my/profile/contact-preferences",
        },
      },
      {
        appName: "reward",
        uri: {
          label: "originenergy/my/reward/fuel/barcode",
        },
      },
      {
        appName: "salesForm",
        uri: {
          label: "originenergy/sign-up/thank-you",
        },
      },
      {
        appName: "staticpages",
        uri: {
          label: "originenergy/spike/signup",
        },
      },
      {
        appName: "unauthenticated:bill-payment",
        uri: {
          label: "originenergy/pay/success",
        },
      },
      {
        appName: "wordpress",
        uri: {
          label: "originenergy/best-deals-on-origin-solar+",
          regex: "originenergy/best-deals-on-origin-solar($|/.+)",
        },
      },
      {
        appName: "wordpress",
        uri: {
          label: "originenergy/electricity-gas/home-support",
        },
      },
      {
        appName: "wordpress",
        uri: {
          label: "originenergy/for-home/campaign/movers-rewards",
        },
      },
      {
        appName: "wordpress",
        uri: {
          label: "originenergy/for-home/campaign/origin-fuel-discount",
        },
      },
      {
        appName: "wordpress",
        uri: {
          label: "originenergy/internet",
        },
      },
      {
        appName: "wordpress",
        uri: {
          label: "originenergy/internet/plans",
        },
      },
      {
        appName: "wordpress",
        uri: {
          label: "originenergy/lpg+",
          regex: "originenergy/(lpg$|for-home/lpg.+)",
        },
      },
      {
        appName: "wordpress",
        uri: {
          label: "originenergy/moving+",
          regex: "originenergy/moving($|/.+)",
        },
      },
      {
        appName: "wordpress",
        uri: {
          label: "originenergy/rewards",
        },
      },
      {
        appName: "wordpress",
        uri: {
          label: "originenergy/solar+",
          regex: "originenergy/solar($|/.+)",
        },
      },
    ],
    navigationCard: [
      {
        appName: "dashboard-rx",
        path: "/my/",
      },
      {
        appName: "rx-my-account:reward",
        path: "/my/reward/rewards-and-offers",
      },
    ],
  },
  forceCreateUser: [
    {
      regex: "/pay/($|.+)",
    },
  ],
};
